import { render, staticRenderFns } from "./StockMovements.vue?vue&type=template&id=4faecd6a&scoped=true&"
import script from "./StockMovements.vue?vue&type=script&lang=ts&"
export * from "./StockMovements.vue?vue&type=script&lang=ts&"
import style0 from "./StockMovements.vue?vue&type=style&index=0&id=4faecd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faecd6a",
  null
  
)

export default component.exports